


























































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { SmartQuery } from 'vue-apollo-decorator';
import { CURRENT_UNIT } from '@/queries/Application';
import { GQL_currentUnit_currentUnit } from '@/queries/__generated__/currentUnit';
import {
  GQL_ameldingAndBookkeepingReconciliationReport,
  GQL_ameldingAndBookkeepingReconciliationReport_ameldingAndBookkeepingReconciliationReport_mostRecentAmeldingReconciliationReports,
 } from "@/queries/__generated__/ameldingAndBookkeepingReconciliationReport";
import Bookkept from './Bookkept.vue';
import BookkeepingSetupButton from './BookkeepingSetupButton.vue';
import { TableData } from './Bookkept.vue';
import AmeldingReconciliationReport from './AmeldingReconciliationReport.vue';
import PaidPaychecks from './PaidPaychecks.vue';
import Diff from './Diff.vue';
import permissionGuard from '@/guards/permission-guard';
import YearSelect from '../YearSelect.vue';
import gql from 'graphql-tag';

const REPORT = gql`
  query ameldingAndBookkeepingReconciliationReport($year: Int!, $unitId: ID!) {
    ameldingAndBookkeepingReconciliationReport(year: $year, unitId: $unitId) {
      bookkeptTable {
        ftrSection
        agaSection
      }
      mostRecentAmeldingReconciliationReports {
        reports {
          id
          calendarMonth
          reimbursement
          salary
          pension
          runningEmployerTaxBase
          employerTax
          taxDeduction
        }
        sum {
          reimbursement
          salary
          pension
          employerTaxBase
          employerTax
          taxDeduction
        }
      }
      diffTable {
        monthly {
          month
          agaBaseDiff
          agaBaseAccumulated
          agaReported
          agaCalculated
          agaDiff
          ftrReported
          ftrBookkept
          ftrDiff
        }
        sums {
          agaBaseDiff
          agaBaseAccumulated
          agaReported
          agaCalculated
          agaDiff
          ftrReported
          ftrBookkept
          ftrDiff
        }
        paychecksNotInYearPaidInYear {
          agaBaseDiff
          agaBaseAccumulated
          agaReported
          agaCalculated
          agaDiff
          ftrReported
          ftrBookkept
          ftrDiff
        }
        paychecksInYearNotPaidInYear {
          agaBaseDiff
          agaBaseAccumulated
          agaReported
          agaCalculated
          agaDiff
          ftrReported
          ftrBookkept
          ftrDiff
        }
        sumsWithPaychecks {
          agaBaseDiff
          agaBaseAccumulated
          agaReported
          agaCalculated
          agaDiff
          ftrReported
          ftrBookkept
          ftrDiff
        }
      }
      paychecksNotInYearPaidInYearTable {
        headers
        rows {
          paycheckId
          paycheckNumber
          lineSums
          employerTaxBase
          taxDeduction
          employerTax
          vacationMoney
          employerTaxOfVacationMoney
          workRelation {
            id
            employmentPercentage
            employmentType
            occupation {
              id
              name
            }
            employee {
              id
              firstName
              lastName
            }
          }
        }
        footer {
          employerTaxBase
          taxDeduction
          employerTax
          vacationMoney
          employerTaxOfVacationMoney
          columnSums
        }
      }
      paychecksInYearNotPaidInYearTable {
        headers
        rows {
          paycheckId
          paycheckNumber
          lineSums
          employerTaxBase
          taxDeduction
          employerTax
          vacationMoney
          employerTaxOfVacationMoney
          workRelation {
            id
            employmentPercentage
            employmentType
            occupation {
              id
              name
            }
            employee {
              id
              firstName
              lastName
            }
          }
        }
        footer {
          employerTaxBase
          taxDeduction
          employerTax
          vacationMoney
          employerTaxOfVacationMoney
          columnSums
        }
      }
    }
  }
`;

@Component({
  components: {
    YearSelect,
    Bookkept,
    BookkeepingSetupButton,
    AmeldingReconciliationReport,
    PaidPaychecks,
    Diff,
  },
  beforeRouteEnter(to, from, next) {
    permissionGuard('canSendAltinnPaycheckReports', to, from, next).catch(router => {
      router.push({ name: 'Dashboard' });
      router.app.$sMessage.error(router.app.$t('noPermissions'));
    });
  },
})
export default class AmeldingAndBookkeepingReconciliation extends Vue {
  @Prop({ type: Number, required: true }) private year!: number; // comes from router

  @SmartQuery({
    query: CURRENT_UNIT,
    result() { this.getReport() },
  }) private currentUnit!: GQL_currentUnit_currentUnit;

  private loading = true;
  private bookkeptTable: TableData | null = null;
  private mostRecentAmeldingReconciliationReports: GQL_ameldingAndBookkeepingReconciliationReport_ameldingAndBookkeepingReconciliationReport_mostRecentAmeldingReconciliationReports | null = null;
  private diffTable!: object;
  private paychecksNotInYearPaidInYearTable!: object;
  private paychecksInYearNotPaidInYearTable!: object;

  @Watch('year')
  private getReport() {
    this.loading = true;

    this.$apollo.query({
      query: REPORT,
      fetchPolicy: 'no-cache',
      variables: {
        year: this.year,
        unitId: this.currentUnit.id,
      },
    }).then((data: {data: GQL_ameldingAndBookkeepingReconciliationReport}) => {
      const report = data.data.ameldingAndBookkeepingReconciliationReport;
      if (!report) return;

      const bookkeptAgaSection = JSON.parse(report.bookkeptTable.agaSection);
      const bookkeptFtrSection = JSON.parse(report.bookkeptTable.ftrSection);
      this.bookkeptTable = {
        agaSection: bookkeptAgaSection,
        ftrSection: bookkeptFtrSection,
      };

      this.mostRecentAmeldingReconciliationReports = report.mostRecentAmeldingReconciliationReports;

      this.diffTable = report.diffTable;

      this.paychecksNotInYearPaidInYearTable = report.paychecksNotInYearPaidInYearTable;
      this.paychecksInYearNotPaidInYearTable = report.paychecksInYearNotPaidInYearTable;

      this.loading = false;
    });
  }
}
